export const DEVICE_GROUPS = {
    robokiFamily: ['Roboki', 'Moki', 'Toki', 'Poki', 'Autoki'],
    mobileDevices: ['Moki', 'Toki', 'Poki'],
    compactDevices: ['Toki', 'Poki'],
}

export const inputRowOneConfig = [
    {
        key: 'isIr',
        activeImg: 'irActive',
        inactiveImg: 'irInActive',
        alt: 'ir',
        visibleDevices: DEVICE_GROUPS.mobileDevices,
    },
    {
        key: 'isSwitch1',
        activeImg: 'switch1Active',
        inactiveImg: 'switch1InActive',
        alt: 'switch1',
        hiddenDevices: DEVICE_GROUPS.compactDevices,
    },
    {
        key: 'isSwitch2',
        activeImg: 'switch2Active',
        inactiveImg: 'switch2InActive',
        alt: 'switch2',
        hiddenDevices: DEVICE_GROUPS.compactDevices,
    },
]

export const inputRowTwoConfig = [
    {
        key: 'isMic',
        activeImg: 'micActive',
        inactiveImg: 'micInActive',
        alt: 'mic',
    },
    {
        key: 'isTemperature',
        activeImg: 'tempActive',
        inactiveImg: 'tempInActive',
        alt: 'temperature',
    },
    {
        key: 'isBattery',
        activeImg: 'batteryActive',
        inactiveImg: 'batteryInActive',
        alt: 'battery',
    },
    {
        key: 'isAccelerometer',
        activeImg: 'accelerometerActive',
        inactiveImg: 'accelerometerInActive',
        alt: 'accelerometer',
        style: {
            width: '18%',
            height: '65.5%',
            marginRight: '5%',
            cursor: 'pointer',
            marginBottom: '2%',
        },
    },
]

export const inputTouchPadConfig = [
    {
        key: 'isTouchZero',
        activeImg: 'touch0Active',
        inactiveImg: 'touch0InActive',
        alt: 'touch0',
        disableSessionKey: 'S1',
    },
    {
        key: 'isTouchOne',
        activeImg: 'touch1Active',
        inactiveImg: 'touch1InActive',
        alt: 'touch1',
        disableSessionKey: 'S2',
    },
    {
        key: 'isTouchTwo',
        activeImg: 'touch2Active',
        inactiveImg: 'touch2InActive',
        alt: 'touch2',
    },
    {
        key: 'isTouchThree',
        activeImg: 'touch3Active',
        inactiveImg: 'touch3InActive',
        alt: 'touch3',
        style: {
            width: '20%',
            height: '70.5%',
            marginRight: '5%',
            cursor: 'pointer',
            marginBottom: '0%',
        },
    },
]

export const inputFourInOneSensorConfig = [
    {
        key: 'isDistanceSensors',
        activeImg: 'distancesensorsActive',
        inactiveImg: 'distancesensorsInActive',
        alt: 'distancesensors',
    },
    {
        key: 'isGestureSensor',
        activeImg: 'gesturesensorActive',
        inactiveImg: 'gesturesensorInActive',
        alt: 'gesturesensor',
        hideWhen2In1: true,
    },
    {
        key: 'isLightSensor',
        activeImg: 'lightsensorActive',
        inactiveImg: 'lightsensorInActive',
        alt: 'lightsensor',
    },
    {
        key: 'isColorSensor',
        activeImg: 'colorsensorActive',
        inactiveImg: 'colorsensorInActive',
        alt: 'colorsensor',
        hideWhen2In1: true,
    },
]

export const outPutData = {
    ATR1: {
        row1: {
            rowClassName: '',
            rowStyle: {},

            internalComponents: {
                atrMotor1: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'atrMotor1',
                    activeImgSrc: 'activeIndividual',
                    inActiveImgSrc: 'inactiveIndividual',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isAtrMotor1',
                },
                atrMotor2: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'atrMotor2',
                    activeImgSrc: 'activeIndividual',
                    inActiveImgSrc: 'inactiveIndividual',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isAtrMotor2',
                },
                atrMotor3: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'atrMotor3',
                    activeImgSrc: 'activeIndividual',
                    inActiveImgSrc: 'inactiveIndividual',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isAtrMotor3',
                },
            },
        },
    },
    // Woof expansion kit outputs — individual servo & action group
    // (mirrors the Humanoid-style outputs, rendered in this PC screen).
    WOOFKIT1: {
        row1: {
            rowClassName: '',
            rowStyle: {},

            internalComponents: {
                individualServo: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'individualServo',
                    activeImgSrc: 'activeIndividual',
                    inActiveImgSrc: 'inactiveIndividual',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isIndivdualServo',
                },
                actionGroup: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'actionGroup',
                    activeImgSrc: 'activeActionGroup',
                    inActiveImgSrc: 'inactiveActionGroup',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isActionGroup',
                },
                oled: {
                    ImgClassName: 'imgStyle_v1',
                    altText: 'oled',
                    activeImgSrc: 'activeWoofOledBtn',
                    inActiveImgSrc: 'inactiveWoofOledBtn',
                    imgTagStyle: { height: 'auto' },
                    reduxName: 'isWoofOled',
                },
            },
        },
    },
}

export const outputPeeCeeRow1Config = [
    {
        key: 'isEYES',
        activeImg: 'EyeActive',
        inactiveImg: 'EyeInActive',
        alt: 'isEYES',
    },
    {
        key: 'isbuzzer',
        activeImg: 'buzzerActive',
        inactiveImg: 'buzzerInActive',
        alt: 'buzzer',
    },
]

export const outputTouchPadConfig = [
    {
        key: 'isTouchZeroOutput',
        activeImg: 'touch0Active',
        inactiveImg: 'touch0InActive',
        alt: 'touch0Output',
        disableSessionKey: 'S1',
    },
    {
        key: 'isTouchOneOutput',
        activeImg: 'touch1Active',
        inactiveImg: 'touch1InActive',
        alt: 'touch1Output',
        disableSessionKey: 'S2',
    },
    {
        key: 'isTouchTwoOutput',
        activeImg: 'touch2Active',
        inactiveImg: 'touch2InActive',
        alt: 'touch2Output',
    },
    {
        key: 'isTouchThreeOutput',
        activeImg: 'touch3Active',
        inactiveImg: 'touch3InActive',
        alt: 'touch3Output',
    },
]

export const outputSmileConfig = [
    {
        key: 'isSmileOne',
        activeImg: 'smile1Active',
        inactiveImg: 'smile1InActive',
        alt: 'smile1',
    },
    {
        key: 'isSmileTwo',
        activeImg: 'smile2Active',
        inactiveImg: 'smile2InActive',
        alt: 'smile2',
    },
    {
        key: 'isSmileThree',
        activeImg: 'smile3Active',
        inactiveImg: 'smile3InActive',
        alt: 'smile3',
    },
    {
        key: 'isSmileFour',
        activeImg: 'smile4Active',
        inactiveImg: 'smile4InActive',
        alt: 'smile4',
    },
]

export const snackbarConfig = [
    { id: 'snackbar1', stateKey: 'isMic', prefix: 'PC', label: 'Microphone' },
    {
        id: 'snackbar2',
        stateKey: 'isTemperature',
        prefix: 'PC',
        label: 'Temperature Sensor',
    },
    {
        id: 'snackbar3',
        stateKey: 'isBattery',
        prefix: 'PC',
        label: 'Internal Battery',
    },
    {
        id: 'snackbar4',
        stateKey: 'isAccelerometer',
        prefix: 'PC',
        label: 'Accelerometer',
    },
    {
        id: 'snackbar5',
        stateKey: 'isTouchZero',
        prefix: 'PC',
        label: 'Touchpad 0',
    },
    {
        id: 'snackbar6',
        stateKey: 'isTouchOne',
        prefix: 'PC',
        label: 'Touchpad 1',
    },
    {
        id: 'snackbar7',
        stateKey: 'isTouchTwo',
        prefix: 'PC',
        label: 'Touchpad 2',
    },
    {
        id: 'snackbar8',
        stateKey: 'isTouchThree',
        prefix: 'PC',
        label: 'Touchpad 3',
    },
    {
        id: 'snackbar9',
        stateKey: 'isTouchZeroOutput',
        prefix: 'PC',
        label: 'Touchpad 0',
    },
    {
        id: 'snackbar10',
        stateKey: 'isTouchOneOutput',
        prefix: 'PC',
        label: 'Touchpad 1',
    },
    {
        id: 'snackbar11',
        stateKey: 'isTouchTwoOutput',
        prefix: 'PC',
        label: 'Touchpad 2',
    },
    {
        id: 'snackbar22',
        stateKey: 'isTouchThreeOutput',
        prefix: 'PC',
        label: 'Touchpad 3',
    },
    { id: 'snackbar12', stateKey: 'isEYES', prefix: 'PC', label: 'RGB leds' },
    { id: 'snackbar13', stateKey: 'isbuzzer', prefix: 'PC', label: 'Buzzer' },
    {
        id: 'snackbar14',
        stateKey: 'isSmileOne',
        prefix: 'PC',
        label: 'Smile Led 1',
    },
    {
        id: 'snackbar15',
        stateKey: 'isSmileTwo',
        prefix: 'PC',
        label: 'Smile Led 2',
    },
    {
        id: 'snackbar16',
        stateKey: 'isSmileThree',
        prefix: 'PC',
        label: 'Smile Led 3',
    },
    {
        id: 'snackbar17',
        stateKey: 'isSmileFour',
        prefix: 'PC',
        label: 'Smile Led 4',
    },
    {
        id: 'snackbar18',
        stateKey: 'isDistanceSensors',
        prefix: 'PC',
        label: 'Distance Sensor',
    },
    {
        id: 'snackbar19',
        stateKey: 'isGestureSensor',
        prefix: 'PC',
        label: 'Gesture Sensor',
    },
    {
        id: 'snackbar20',
        stateKey: 'isLightSensor',
        prefix: 'PC',
        label: 'Light Sensor',
    },
    {
        id: 'snackbar21',
        stateKey: 'isColorSensor',
        prefix: 'PC',
        label: 'Color Sensor',
    },
]

export const snackbarDeviceConfig = [
    {
        id: 'snackbar23',
        stateKey: 'isSwitch1',
        label: 'Switch 1',
        deselectedLabel: 'switch 1',
        devicePrefixMap: { Moki: 'Moki', default: 'Roboki' },
        style: {},
        mobileStyle: { left: '-14%' },
        mobileDevices: ['Moki'],
    },
    {
        id: 'snackbar24',
        stateKey: 'isSwitch2',
        label: 'Switch 2',
        deselectedLabel: 'switch 2',
        devicePrefixMap: { Moki: 'Moki', default: 'Roboki' },
        style: {},
        mobileStyle: { left: '-14%' },
        mobileDevices: ['Moki'],
    },
    {
        id: 'snackbar_joystick',
        stateKey: 'isJoystick',
        label: 'Joystick',
        useConnectedDevice: true,
        style: { left: '-14%' },
    },
    {
        id: 'ir1',
        stateKey: 'isIr',
        label: 'Ir',
        useConnectedDevice: true,
        style: {},
        mobileStyle: { left: '-14%' },
        mobileDevices: ['Moki', 'Toki', 'Poki'],
    },
]

export const snackbarBottomConfig = [
    {
        id: 'snackbar25',
        stateKey: 'isLeftEye',
        prefix: 'Roboki',
        label: 'Left Eye',
    },
    {
        id: 'snackbar26',
        stateKey: 'isRightEye',
        prefix: 'Roboki',
        label: 'Right Eye',
    },
]

export const snackbarWarningConfig = [
    {
        id: 'snackbar3_A1',
        conditionKeys: ['isTouchZero', 'isTouchZeroOutput'],
        message: 'Disable S1 to Enable Touch Pad 0',
    },
    {
        id: 'snackbar7_B1',
        conditionKeys: ['isTouchOne', 'isTouchOneOutput'],
        message: 'Disable S2 to Enable Touch Pad 1',
    },
]

export const deviceOverlayConfig = {
    robokiEyes: [
        {
            stateKey: 'isLeftEye',
            style: { top: '45.5%', width: '6%', left: '41%' },
        },
        {
            stateKey: 'isRightEye',
            style: { top: '45.5%', width: '6%', left: '52%' },
        },
    ],
    peeCeeEyePositions: [31.5, 38.5, 44.8, 52, 58, 64.5],
    peeCeeEyeRows: ['49%', '54.5%'],
    peeCeeTeeth: [
        {
            stateKey: 'isSmileOne',
            style: { top: '74.9%', width: '1.6%', left: '43%' },
        },
        {
            stateKey: 'isSmileTwo',
            style: { top: '75.9%', width: '1.6%', left: '45.2%' },
        },
        {
            stateKey: 'isSmileThree',
            style: { top: '75.9%', width: '1.6%', left: '53.4%' },
        },
        {
            stateKey: 'isSmileFour',
            style: { top: '74.9%', left: '55.5%', width: '1.6%' },
        },
    ],
    peeCee4in1: { style: { top: '76%', left: '48%', width: '4%' } },
    peeCeeMic: { style: { left: '50%', top: '-18%' } },
    peeCeeBuzzer: { style: { left: '6%' } },
    touchpads: [
        {
            inputKey: 'isTouchZero',
            outputKey: 'isTouchZeroOutput',
            className: 'imgStyleTouchpads1_v1',
            style: {
                bottom: '-18%',
                left: '16%',
                width: '19%',
                height: '15%',
                borderRadius: '15% 26% 1% 13%',
            },
        },
        {
            inputKey: 'isTouchOne',
            outputKey: 'isTouchOneOutput',
            className: 'imgStyleTouchpads2_v1',
            style: {
                bottom: '-18.5%',
                left: '30%',
                width: '18%',
                height: '15%',
                borderRadius: '15% 13% 1% 13%',
            },
        },
        {
            inputKey: 'isTouchTwo',
            outputKey: 'isTouchTwoOutput',
            className: 'imgStyleTouchpads2_v1',
            style: {
                bottom: '-18.5%',
                left: '49.3%',
                width: '18%',
                height: '15%',
                borderRadius: '15% 13% 1% 13%',
            },
        },
        {
            inputKey: 'isTouchThree',
            outputKey: 'isTouchThreeOutput',
            className: 'imgStyleTouchpads3_v1',
            style: {
                bottom: '-18%',
                left: '79%',
                width: '17%',
                height: '15%',
                borderRadius: '15% 13% 16% 13%',
            },
        },
    ],
    activeColor: 'rgb(255 153 64 / 94%)',
    inactiveColor: 'rgb(176 174 161 / 95%)',
}

export const outputRobokiEyesConfig = [
    {
        key: 'isLeftEye',
        activeImg: 'lefteyeActive',
        inactiveImg: 'lefteyeInActive',
        alt: 'leftEye',
    },
    {
        key: 'isRightEye',
        activeImg: 'righteyeActive',
        inactiveImg: 'righteyeInActive',
        alt: 'rightEye',
    },
]

export const tostMessages = {
    atrMotor1: {
        tostDivId: 'snackbar_atrMotor1',
        tostDivClass: 'bottom0',
        activeMessage: ' - Motor 1 selected',
        InactiveMessage: ' - Motor 1 deselected',
    },
    atrMotor2: {
        tostDivId: 'snackbar_atrMotor2',
        tostDivClass: 'bottom0',
        activeMessage: ' - Motor 2 selected',
        InactiveMessage: ' - Motor 2 deselected',
    },
    atrMotor3: {
        tostDivId: 'snackbar_atrMotor3',
        tostDivClass: 'bottom0',
        activeMessage: ' - Motor 3 selected',
        InactiveMessage: ' - Motor 3 deselected',
    },
    individualServo: {
        tostDivId: 'snackbar_woofIndividualServo',
        tostDivClass: 'bottom0',
        activeMessage: ' - Individual Servo selected',
        InactiveMessage: ' - Individual Servo deselected',
    },
    actionGroup: {
        tostDivId: 'snackbar_woofActionGroup',
        tostDivClass: 'bottom0',
        activeMessage: ' - Action Group selected',
        InactiveMessage: ' - Action Group deselected',
    },
    oled: {
        tostDivId: 'snackbar_woofOled',
        tostDivClass: 'bottom0',
        activeMessage: ' - OLED selected',
        InactiveMessage: ' - OLED deselected',
    },
}
